import { ORDER_PROPOSAL_STATUS } from '@/typings/enums/ORDER_PROPOSAL_STATUS';
import OrderClientProposalApiClient from '@/api/OrderClientProposalApiClient';
import { useNotif, usePrompt } from '@orion.ui/orion';

class OrderClientProposalService {

	async getDetailsAsync (...args: Parameters<typeof OrderClientProposalApiClient.getDetails>) {
		const { data } = await OrderClientProposalApiClient.getDetails(...args);
		return data;
	}

	async acceptProposalAsync (orderClientProposals: IOrderClientProposalWithUserModel[]) {
		const ids = orderClientProposals.mapKey('id');
		const { confirm, value: comment } = await usePrompt<string>({
			title: 'Confirmation',
			message: `Souhaitez-vous accepter ${'ce candidat'.pluralize(ids.length, false)} ?
								<div class="arm-alert arm-alert--info arm-alert--center" style="margin:10px auto 20px">
									Vous avez la possibilité d'ajouter un commentaire à destination de l'agence
								</div>`,
			prompt: {
				type: 'textarea',
				fieldProps: { label: `Commentaire optionnel` },
			},
		});

		if (confirm) {
			await OrderClientProposalApiClient.update({
				ids,
				hasAccepted: true,
				comment: comment === null ? undefined : comment,
			});

			orderClientProposals.forEach((x) => {
				x.responseDate = new Date().toString();
				x.status = ORDER_PROPOSAL_STATUS.Accepted;
			});

			useNotif.success(ids.length > 1
				? `Les candidats ont bien été acceptés`
				: `Le candidat a bien été accepté`,
			);
		}

		return {
			confirm,
			comment,
		};
	}

	async declineProposalAsync (orderClientProposals: IOrderClientProposalWithUserModel[]) {
		const ids = orderClientProposals.mapKey('id');
		const { confirm, value: comment } = await usePrompt<string>({
			title: 'Confirmation',
			message: `Souhaitez-vous refuser ${'ce candidat'.pluralize(ids.length, false)} ?`,
			prompt: {
				type: 'textarea',
				fieldProps: { label: `Commentaire optionnel à destination de l'agence` },
			},
		});

		if (confirm) {
			await OrderClientProposalApiClient.update({
				ids,
				hasAccepted: false,
				comment: comment === null ? undefined : comment,
			});

			orderClientProposals.forEach((x) => {
				x.responseDate = new Date().toString();
				x.status = ORDER_PROPOSAL_STATUS.Refused;
			});

			useNotif.success(ids.length > 1
				? `Les candidats ont bien été refusés`
				: `Le candidat a bien été refusé`,
			);
			return { comment };
		}

		return {
			confirm,
			comment,
		};
	}

	async gridAsync (...args: Parameters<typeof OrderClientProposalApiClient.grid>) {
		const { data } = await OrderClientProposalApiClient.grid(...args);
		return data;
	}

	async countAsync (...args: Parameters<typeof OrderClientProposalApiClient.count>) {
		const { data } = await OrderClientProposalApiClient.count(...args);
		return data;
	}
}

const orderClientProposalServiceSingleton = new OrderClientProposalService();

export default function useOrderClientProposalService () {
	return orderClientProposalServiceSingleton;
}
